import React, { PropsWithChildren, createContext } from 'react';
import { UseFormMethods, FormProvider, FieldValues } from 'react-hook-form';
import { InitResponse, PresetsInitResponse } from './redux/types';
import { SubmitPubSub } from './hooks/useSubmitPubSub';
import { SubmitAdapter, SubmitFormParams } from './types';

export interface SubmitFormContextValue {
  formContext: UseFormMethods<any>; // react-hook-form context
  registerValidator: (name: string, validator: any) => void;
  registerSubmitAdapter: (name: string, adapter: SubmitAdapter) => void;
  unregisterValidator: (name: string) => void;
  unregisterSubmitAdapter: (name: string) => void;
  registerNestedForm: <T extends FieldValues>(
    name: string,
    formMethods: UseFormMethods<T>
  ) => void;
  unregisterNestedForm: (name: string) => void;
  hasNestedForms: () => boolean;
  submitAllNestedForms: () => Promise<Array<{ name: string; data: any }>>;
  refreshInitData: () => void;
  scrollableRef: React.MutableRefObject<HTMLElement | undefined | null>;
  scrollToField: (fieldWrapperEl: HTMLElement) => void;
  initResponse?: InitResponse;
  presetsInitResponse?: PresetsInitResponse;
  isEdit?: boolean;
  isDraft?: boolean;
  params: SubmitFormParams;
  pubsub: SubmitPubSub;
}

export const SubmitFormContext = createContext<
  SubmitFormContextValue | undefined
>(undefined);

export const SubmitFormProvider: React.FC<
  PropsWithChildren<SubmitFormContextValue>
> = ({ children, formContext, ...contextProps }) => {
  return (
    <SubmitFormContext.Provider value={{ ...contextProps, formContext }}>
      <FormProvider {...formContext}>{children}</FormProvider>
    </SubmitFormContext.Provider>
  );
};
